import CommissionThumbWithMenuContainer from './CommissionThumbWithMenu.container';
import CommissionThumbWithMenu from './CommissionThumbWithMenu';

export default CommissionThumbWithMenuContainer(CommissionThumbWithMenu);
